<template>
  <div class="break-inside rounded-md bg-gray-600 p-4 text-center mb-4">
    <div class="mb-2">
      <RouterLink :to="`/astronomers/${session.astronomer.slug}`">
        <img
          v-if="session.astronomer.avatar_url"
          :src="session.astronomer.avatar_url"
          :title="session.astronomer.username"
          class="w-10 rounded-full mx-auto"
        />
        <span v-else class="text-sm">{{ session.astronomer.username }}</span>
      </RouterLink>
    </div>

    <RouterLink :to="`/astronomers/${session.astronomer.slug}/targets/${session.target.id}`">
      <h3 class="text-yellow-300" :title="session.target.name">
        {{ truncate(session.target.name, 30) }}
      </h3>
    </RouterLink>

    <div>
      <template v-for="stat in session.image_stats" :key="`${stat.filter}-${stat.duration}`">
        <template v-if="stat.filter">
          <strong>{{ stat.filter }}:</strong>
        </template>
        {{ stat.count }}x{{ stat.duration }}s
        <span class="hidden md:inline text-xs">
          ({{ (stat.total / 3600).toFixed(2) }} hours)
        </span>
        <br />
      </template>
    </div>

    <h5 class="mt-4">Last Image</h5>
    <img
      v-if="session.last_image_thumbnail"
      class="mx-auto"
      :src="`data:image/jpeg;base64, ${session.last_image_thumbnail}`"
    />

    <span class="text-xs" :title="session.session_ended_at">
      {{ timeAgo(session.session_ended_at) }} ago
      <template v-if="session.last_image_rms && session.last_image_rms > 0">
        | RMS: {{ session.last_image_rms.toFixed(2) }}"
      </template>
    </span>

    <template v-if="session.can_monitor">
      <br />
      <RouterLink
        :to="`/astronomers/${session.astronomer.slug}/sessions/${session.id}`"
        class="text-xs text-yellow-300"
      >Monitor</RouterLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { timeAgo } from '../utils/timeAgo'

interface ImageStat {
  filter: string | null
  count: number
  duration: number
  total: number
}

interface Astronomer {
  id: number
  username: string
  avatar_url: string | null
  slug: string
}

interface Target {
  id: number
  name: string
}

interface Session {
  id: number
  session_ended_at: string
  last_image_thumbnail: string | null
  last_image_rms: number | null
  can_monitor: boolean
  image_stats: ImageStat[]
  astronomer: Astronomer
  target: Target
}

defineProps<{ session: Session }>()

function truncate(str: string, length: number): string {
  return str.length > length ? str.slice(0, length) + '...' : str
}
</script>
